import { render, staticRenderFns } from "./ReSharePercent.vue?vue&type=template&id=08fffcd8&scoped=true"
import script from "./ReSharePercent.vue?vue&type=script&lang=js"
export * from "./ReSharePercent.vue?vue&type=script&lang=js"
import style0 from "./ReSharePercent.vue?vue&type=style&index=0&id=08fffcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fffcd8",
  null
  
)

export default component.exports